import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { showSnackbar } from '../../../components/snackbar/actions';
import { useApi } from '../../../config/api';

export const useUserDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { api, apiEndpoints } = useApi();

  const { data: { data: { data: selectedUser = {} } = {} } = {} } = useQuery(
    ['userDetails', id],
    () => api().get(apiEndpoints.singleUser(id)),
    {
      onError: (err) => {
        dispatch(
          showSnackbar({
            type: 'error',
            message: err.message
          })
        );
      }
    }
  );

  return { selectedUser };
};
